import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||286}
    height={props.width?(props.width/286*221):221}
    fill="none"
    viewBox="0 0 286 221"
    {...props}
  >
    <path
      fill="#9B8C6F"
      d="M76.2 193.26h13.96v4H76.2v-4Zm-10.88 22h35.4v4.04h-35.4v-4.04Zm1.44-31.2H79.2v3.88H66.76v-3.88Zm11.04 0h.84l.84-.2 3.2 1.56c-2.92 8.04-9.28 13.92-16.08 17.28-.64-1.08-1.96-2.72-2.92-3.6 5.96-2.56 11.92-8.2 14.12-14.2v-.84Zm9.12-1.36c2.8 6.8 8.4 12.8 15.56 15.64-1.08.92-2.52 2.8-3.28 4.08-7.6-3.52-13.16-10.2-16.52-18.4l4.24-1.32Zm-20.68 8.72 2.6-2.64c1.76 1 3.96 2.56 5 3.76l-2.68 2.92c-1-1.2-3.16-2.88-4.92-4.04Zm26.84-8.48 3.6 2.56c-2.2 1.88-4.8 3.84-6.8 5.12L87 188.38c1.92-1.36 4.56-3.68 6.08-5.44Zm4.52 4.68 3.52 2.48c-2.28 2-5.04 4.08-7.16 5.4l-2.88-2.24c2.08-1.44 4.88-3.8 6.52-5.64Zm-21.92 15.76v3.44h14.04v-3.44H75.68Zm-4.84-3.84h24.04v11.08H70.84v-11.08Zm2.68 12.12 4.32-1.36c.92 1.28 1.76 3.08 2.08 4.28l-4.52 1.56c-.24-1.2-1.04-3.12-1.88-4.48Zm14.32-1.16 4.68 1c-1.04 2-2 3.92-2.84 5.24l-4.2-.96c.84-1.44 1.88-3.68 2.36-5.28Zm36.44-12.96h13.04v4.52h-13.04v-4.52Zm-1.88 0h4.84v15.6c0 1.72.32 2 2.24 2h5.6c1.84 0 2.12-.92 2.4-5.96 1.04.76 3.08 1.6 4.44 1.88-.6 6.68-1.92 8.6-6.48 8.6h-6.56c-4.96 0-6.48-1.36-6.48-6.48v-15.64Zm-.16-12.96h17.4v19.48h-4.84v-14.92h-12.56v-4.56Zm-16.04 9.96h12.76v3.56H106.2v-3.56Zm-.8 5.76h14.24v3.6H105.4v-3.6Zm-1.16-11.72h16.72v3.8h-16.72v-3.8Zm4.08 17.4h10.6v12.28h-10.6v-3.8h6.4v-4.68h-6.4v-3.8Zm-2.32 0h4.16v13.88H106v-13.88Zm2.56-21.84 3.84-1.88c1.28 1.52 2.56 3.52 3.12 4.96l-4 2.12c-.52-1.4-1.76-3.64-2.96-5.2Zm43.88 10.08h20.76v4.4h-20.76v-4.4Zm-7.36 7.36h35.84v4.48h-35.84v-4.48Zm9.96 3.28h4.92c-.4 8.48-1.88 13.12-13.12 15.28-.36-1.2-1.56-3.08-2.48-4.08 9.64-1.56 10.36-4.56 10.68-11.2Zm10.24-.64h4.88v9.56c0 1.28.2 1.44 1.6 1.44h3.92c1.24 0 1.48-.68 1.64-4.88 1 .76 3.04 1.52 4.32 1.84-.52 5.84-1.76 7.4-5.52 7.4h-5.04c-4.68 0-5.8-1.44-5.8-5.8v-9.56ZM145.8 186.7h34.24v10h-5v-5.4H150.6v5.4h-4.8v-10Zm13.32-3.16 4.92-1.4c1.04 1.76 2.12 4.16 2.52 5.76l-5.24 1.56c-.32-1.52-1.24-4.04-2.2-5.92Zm31.12 14.08h9.24v4.4h-9.24v-4.4Zm7.4 0h4.68s-.04 1.2-.04 1.76c-.16 8.48-.36 12.04-1.28 13.28-.8 1-1.6 1.36-2.76 1.56-1.08.16-2.8.16-4.68.12-.08-1.4-.6-3.28-1.32-4.48 1.44.16 2.8.16 3.44.16.56 0 .92-.08 1.24-.48.48-.64.64-3.44.72-11.2v-.72Zm12.04-12.52 2.88-2.92c2.2 1.16 5.16 3 6.6 4.32l-3.08 3.24c-1.32-1.4-4.16-3.36-6.4-4.64Zm4.72 10.28 4.84 1.16c-3.36 10.44-9.24 18.56-17.16 23.44-.72-1-2.48-3-3.48-3.96 7.68-4.12 13.04-11.36 15.8-20.64Zm-23.88-6.8h30.84v4.72h-30.84v-4.72Zm-3.2 0h5.04v11.76c0 6-.68 14.88-4.32 20.28-.8-.96-2.96-2.72-4.08-3.28 3.08-4.8 3.36-11.8 3.36-17.04v-11.72Zm16.24-5.96h5.04c-.28 16.32 3.4 32.36 7.44 32.36.92 0 1.4-2.04 1.64-7.08 1.08 1.12 2.8 2.24 4.08 2.72-.76 7.44-2.36 9.24-6.12 9.24-8.72 0-11.96-19-12.08-37.24Z"
    />
    <circle
      cx={143.379}
      cy={83.883}
      r={82.883}
      fill="url(#aa)"
      stroke="url(#bb)"
      strokeWidth={2}
    />
    <path
      stroke="#ECEEEE"
      strokeWidth={26}
      d="m98.97 91.55 35.221 30.669 53.597-76.672"
    />
    <defs>
      <linearGradient
        id="aa"
        x1={143.379}
        x2={143.379}
        y1={0}
        y2={167.766}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C866B" />
        <stop offset={0.14} stopColor="#8F896D" stopOpacity={0.96} />
        <stop offset={0.32} stopColor="#999274" stopOpacity={0.84} />
        <stop offset={0.53} stopColor="#A9A07F" stopOpacity={0.63} />
        <stop offset={0.76} stopColor="#C0B58E" stopOpacity={0.36} />
        <stop offset={1} stopColor="#DDCFA2" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="bb"
        x1={66.391}
        x2={224.971}
        y1={71.246}
        y2={101.124}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.08} stopColor="#8C866B" />
        <stop offset={0.26} stopColor="#8C866A" />
        <stop offset={0.45} stopColor="#F5E6B6" />
        <stop offset={0.59} stopColor="#7D7649" />
        <stop offset={0.84} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
